import { Pipe, PipeTransform } from '@angular/core';

const FILE_TYPE_FALLBACK = 'bin';

export function transformFileExtension(fileName: string | null): string {
  if (fileName === undefined || fileName === null || fileName.length === 0) {
    return '';
  }

  const splittedFileName = fileName.split('.');

  const newFileType =
    splittedFileName.length > 1
      ? splittedFileName[splittedFileName.length - 1]
      : FILE_TYPE_FALLBACK;

  return newFileType.toLowerCase();
}

@Pipe({
  name: 'fileExtension',
})
export class FileExtensionPipe implements PipeTransform {
  transform(value: string): string {
    return transformFileExtension(value);
  }
}
